import { createSlice } from '@reduxjs/toolkit';

export const languageSlice = createSlice({
    name: 'language',
    initialState: {
        language: 'es'
    },
    reducers: {
        change: (state, action) => {
            state.language = (state.language === 'es') ? 'en' : 'es';
        }
    }
});


export const { change } = languageSlice.actions;